// import React, { useState } from 'react';
// import ImageSelectionModal from '../../pages/FormMenuItem/ImageSelectionModal';
// import { useDispatch, useSelector } from 'react-redux';
// import { addCategory, updateCategory } from '../../redux/action';

// function CategoryForm() {
//     // const edit ={ id: '', image:'', name: '', description: '' }
//     //const edit =  {id: 1, image:"https://github.com/user-attachments/assets/fc5a949f-8931-4c3f-bab5-7db4164f732a", name: "Starters", description: "Appetizers and small bites" }
//     const edit = useSelector((state) => state?.admin?.edit)
//     const e = edit?.categoryId ? edit : { categoryId: '', categoryImage: '', categoryName: '', description: '' }
//     const [categoryName, setName] = useState(e.categoryName);
//     const restaurantOrBranchId = '';
//     const categoryId = '';
//     const [categoryImage, setFile] = React.useState(e.categoryImage);
//     const [description, setDescription] = useState(e.description);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [errors, setErrors] = useState({});
//     const dispatch = useDispatch();

//     const validateForm = () => {
//         const newErrors = {};
//         if (!categoryName.trim()) newErrors.categoryName = 'Name is required';
//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleSubmit = (e) => {

//         e.preventDefault();
//         if (validateForm()) {

//             const categoryData = { restaurantOrBranchId, categoryName, categoryImage, description, categoryId };
//             console.log("trigger handleSubmit ")

//             if (edit?.categoryId) {
//                 categoryData.categoryId = edit.categoryId;
//                 console.log("trigger edit category ")
//                 dispatch(updateCategory(categoryData));
//                 // dispatch(editUser({}));
//             } else {
//                 dispatch(addCategory(categoryData));
//             }

//             // Clear form fields af ter submission
//             setName('');
//             setDescription('');
//             setFile('');
//             setErrors({});
//         }
//     }

//     const handleImageSelected = (selectedImageUrl) => {
//         // setFormData((prevData) => ({
//         //   ...prevData,
//         //   imageUrl: selectedImageUrl, // Set imageUrl from modal selection
//         //   imageFile: null, // Clear imageFile if an image is selected from gallery
//         // }));
//         // setThumbnailUrl(selectedImageUrl);
//         closeImageModal();
//     };

//     const openImageModal = () => {
//         setIsModalOpen(true);
//     };

//     const closeImageModal = () => {
//         setIsModalOpen(false);
//     };


//     return (
//         <div>
//             <form onSubmit={handleSubmit} style={styles.form}>

//                 <div style={styles.formGroup}>
//                     <label htmlFor="categoryName" style={styles.label}>Name:</label>
//                     <input
//                         type="text"
//                         id="categoryName"
//                         value={categoryName}
//                         onChange={(e) => setName(e.target.value)}
//                         style={styles.input}
//                     />
//                     {errors.categoryName && <p style={styles.errorText}>{errors.categoryName}</p>}
//                 </div>

               

//                 <button type="submit" style={styles.button}>
//                     {edit?.categoryId ? 'Edit Category' : 'Add Category'}
//                 </button>
//             </form>

//             {isModalOpen && (
//                 <ImageSelectionModal
//                     onClose={closeImageModal}
//                     onSelectImage={handleImageSelected}
//                 />
//             )}
//         </div>
//     );

// }

// const styles = {
//     form: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '15px',
//     },
//     browseButtonStyle: {
//         backgroundColor: '#0078d4',
//         color: 'white',
//         padding: '10px 15px',
//         borderRadius: '4px',
//         cursor: 'pointer',
//         border: 'none',
//         display: 'inline-block',
//         marginTop: '5px',
//         marginRight: '10px'
//     },
//     formGroup: {
//         marginBottom: '10px',
//         textAlign: 'left',
//     },
//     label: {
//         display: 'block',
//         marginBottom: '5px',
//         fontWeight: 'bold',
//         color: '#333',
//     },
//     input: {
//         width: '100%',
//         padding: '10px',
//         border: '1px solid #ccc',
//         borderRadius: '4px',
//         boxSizing: 'border-box',
//     },
//     select: {
//         width: '100%',
//         padding: '10px',
//         border: '1px solid #ccc',
//         borderRadius: '4px',
//         boxSizing: 'border-box',
//         backgroundColor: '#fff',
//     },
//     button: {
//         padding: '12px 20px',
//         backgroundColor: '#0078d4',
//         color: 'white',
//         border: 'none',
//         borderRadius: '5px',
//         cursor: 'pointer',
//         fontSize: '16px',
//         fontWeight: 'bold',
//         transition: 'background-color 0.2s ease-in-out',
//     },
//     errorText: {
//         color: 'red',
//         fontSize: '0.85em',
//         marginTop: '5px',
//     },
// };

// export default CategoryForm;

import React, { useState } from 'react';
import ImageSelectionModal from '../../pages/FormMenuItem/ImageSelectionModal';
import { useDispatch, useSelector } from 'react-redux';
import { addCategory, updateCategory } from '../../redux/action';
import { useMobileFormDraft } from '../../Utills/useMobileFormDraft';
import LocalizedContentFields from '../LocalizedContentFields/LocalizedContentFields';
import { emptyContentTranslations } from '../../i18n/contentTranslationApi';

function CategoryForm() {
    const edit = useSelector((state) => state?.admin?.edit);
    const globalPopupKey = useSelector((state) => state.user?.globalPopupKey);
    const categorySaving = useSelector((state) => Boolean(state.admin?.categorySaving));
    const isPopupOpen = Boolean(globalPopupKey);

    const initialValues = {
        categoryName: edit?.categoryName || '',
        categoryImage: edit?.categoryImage || '',
        description: edit?.description || ''
    };

    // Pass `isPopupOpen` so the hook knows when to reset/restore
    const [formData, setFormData, clearDraft] = useMobileFormDraft(
        edit?.categoryId ? `edit_category_${edit.categoryId}` : "add_category",
        initialValues,
        isPopupOpen
    );

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [translations, setTranslations] = useState(emptyContentTranslations);
    const submitLock = React.useRef(false);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!categorySaving) submitLock.current = false;
    }, [categorySaving]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.categoryName.trim()) newErrors.categoryName = 'Name is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (categorySaving || submitLock.current) return;
        if (validateForm()) {
            submitLock.current = true;
            const categoryData = {
                categoryName: formData.categoryName,
                categoryImage: formData.categoryImage,
                description: formData.description
                ,translations
            };

            if (edit?.categoryId) {
                categoryData.categoryId = edit.categoryId;
                dispatch(updateCategory(categoryData));
            } else {
                dispatch(addCategory(categoryData));
            }

            clearDraft();
            setErrors({});
        }
    };

    return (
        <div>
            <form id="category-form" onSubmit={handleSubmit} style={styles.form}>
                <div style={styles.formGroup}>
                    <label htmlFor="categoryName" style={styles.label}>Name:</label>
                    <input
                        type="text"
                        id="categoryName"
                        value={formData.categoryName}
                        onChange={(e) => setFormData({ ...formData, categoryName: e.target.value })}
                        style={styles.input}
                    />
                    {errors.categoryName && <p style={styles.errorText}>{errors.categoryName}</p>}
                </div>

                <LocalizedContentFields
                    entityType="category"
                    entityId={edit?.categoryId}
                    value={translations}
                    onChange={setTranslations}
                    fields={[
                        { name: 'name', label: 'Translated name', placeholder: 'Enter translated category name' },
                        { name: 'description', label: 'Translated description', placeholder: 'Enter translated description', multiline: true }
                    ]}
                />

            </form>
        </div>
    );
}

const styles = {
    form: { display: 'flex', flexDirection: 'column', gap: '15px' },
    formGroup: { marginBottom: '10px', textAlign: 'left' },
    label: { display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' },
    input: { width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' },
    button: { padding: '12px 20px', backgroundColor: '#16a34a', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold' },
    errorText: { color: 'red', fontSize: '0.85em', marginTop: '5px' }
};

export default CategoryForm;
